export default __webpack_public_path__ + "static/media/02.60e996bb.svg";